import Service from 'ember-keyboard/services/keyboard';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import { handleKeyEventWithPropagation } from 'ember-keyboard/utils/handle-key-event';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      service — app-local override of ember-keyboard's KeyboardService:
 *              suppresses most global key-responder shortcuts while focus is on an
 *              INPUT/TEXTAREA/contenteditable, except Escape/ArrowUp/ArrowDown.
 *   extends:   Service (ember-keyboard/services/keyboard) (addon) — subclasses the
 *              addon's base service to override `_respond`
 *   template:  none
 *   key:       _respond (@action, the addon's key-event entry point)
 *   uses:      ember-keyboard/utils/handle-key-event (handleKeyEventWithPropagation),
 *              @ember/runloop (run)
 *   siblings:  -
 *   tests:     keyboard-test.js
 *   gotchas:   -
 *
 * Storefront-local guard on top of ember-keyboard: form fields eat global
 * keyboard shortcuts except Escape/Arrow-Up/Arrow-Down.
 */
export default class KeyboardService extends Service {
  @action
  _respond(event) {
    this._disableOnInput = true;

    if (this._disableOnInput && event.target) {
      const target = event.composedPath()[0] ?? event.target;
      const key = event.key;
      const tag = target.tagName;
      const isContentEditable =
        target.getAttribute && target.getAttribute('contenteditable') != null;

      if (
        key !== 'Escape' &&
        key !== 'ArrowDown' &&
        key !== 'ArrowUp' &&
        (isContentEditable || tag === 'TEXTAREA' || tag === 'INPUT')
      ) {
        return;
      }
    }
    run(() => {
      const { firstResponders, normalResponders } = this;
      handleKeyEventWithPropagation(event, {
        firstResponders,
        normalResponders,
      });
    });
  }
}
